// extracted by mini-css-extract-plugin
export var cancelButton = "_nx-5";
export var content = "_nx-3";
export var createButton = "_nx-6";
export var drawerContainer = "_nx-0";
export var footer = "_nx-2";
export var header = "_nx-1";
export var orderFormColumn = "_nx-4";